<template>
  <div id="titleWithMessage" :class="{'smallContent' : contentSmall}">
    <div class="twm-title" :class="{'small' : contentSmall}">
      {{ title }}
    </div>
    <div class="twm-message" :class="{'small' : contentSmall}">
      {{ message }}
    </div>
    <v-btn
      v-if="btnOption"
      id="btnOption"
      :color="$btnHwayzBlue"
      dark
      :small="contentSmall"
      @click.stop="$emit('button-clicked')"
    >
      {{ btnOption }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    btnOption: {
      type: String,
      default: null
    },
    contentSmall: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="sass" scoped>
#titleWithMessage
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  min-height: 60vh

  .twm-title
    font-size: 3rem
    margin-bottom: 2rem
    &.small
      font-size: 2.4rem

  .twm-message
    font-size: 2rem
    margin-bottom: 2rem
    &.small
      font-size: 1.6rem

  #btnOption
    width: 80%
    max-width: 20rem

.smallContent
  min-height: 40vh !important

</style>
